import React from 'react';
import { Reveal } from './Reveal';
import type { Principle } from '../types/content';
interface PrincipleListProps {
  items: Principle[];
  columns?: 2 | 4;
}
export function PrincipleList({
  items,
  columns = 2
}: PrincipleListProps) {
  const grid = columns === 4 ? 'sm:grid-cols-2 lg:grid-cols-4' : 'sm:grid-cols-2';
  return <ul className={`grid gap-x-10 gap-y-10 ${grid}`} data-id="element-178" data-mp="1ngk00uvfiomz">
      {items.map((item, i) => <li key={item.title} className="border-t border-midnight-900/15 pt-6" data-id="element-179" data-mp="2k3yg2qx68jkh" data-mpi={i}>
          <Reveal delay={i * 0.04} data-id="element-180" data-mp="2g3ek3qoc3lzx">
            <h3 className="font-serif text-2xl text-midnight-900" data-id="element-181" data-mp="2g4ftlqppc0fj">{item.title}</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-midnight-900/70" data-id="element-182" data-mp="2b39xrk0qvx1s">{item.description}</p>
          </Reveal>
        </li>)}
    </ul>;
}